import { send } from '../../../../../../../src/network';

export type PatchBundleRatingsPostBody = {
  customer_id: number;
  bundle_id: number;
  liked: boolean | null;
  feedback?: string | null;
  pairing: number | null;
};

export type PatchBundleRatingsResponse = {
  bundle: number;
  liked: boolean | null;
  feedback: string | null;
  pairing: number | null;
};

export function getPath({
  customerId,
  bundleId,
}: {
  customerId: number | ':id';
  bundleId: number | ':bundle_id';
}) {
  return `/api/v2/customers/${customerId}/bundle_ratings/${bundleId}/`;
}

export async function patchBundleRating(params: PatchBundleRatingsPostBody) {
  const { customer_id: customerId, bundle_id: bundleId, ...rest } = params;
  return send<PatchBundleRatingsResponse>({
    method: 'PATCH',
    body: rest,
    path: getPath({ customerId, bundleId }),
  });
}
